import axios from 'axios';

const envApi = process.env.REACT_APP_API_URL || '';
//export const api = 'http://localhost:8000/api/';
export const api = envApi ? `${envApi.replace(/\/$/, '')}/api/` : '/api/';

// Remarque : rebuild du front nécessaire si vous changez REACT_APP_API_URL


